import * as post from '@/port/clientSide/widgetOneLayer'//- 签章和区块链 路径
import { postFun } from '@/api/utils'//- 签章和区块链 路径
import {randomHexString, randomString, generateSign} from "@/api/sign";
import { ElMessage } from 'element-plus';

//签章
export function onGetSha(param) {
  //哈希获取
  return new Promise(function (resolve) {
    let data = { files: [] }
    param.forEach(item => {
      data.files.push(item.response.split("/")[2])
    });
    post.getSha(data).then(res => {
      if (res.code === 0) {
        resolve(res.data)
      } else {
        onError(res)
      }
    }).catch(error => { console.log(error) })
  })
}
export async function beginsignet(fileobj) {
  let hashadata = await onGetSha([fileobj])
  let param = {
    account: userinfo().username,
    docName: fileobj.name,
    fileUrl: fileobj.url,
    autoArchive: false,
    wishAuthType: 0,
    isRealNameAuthentication: 0,
    isLimitSignUserAccount: 0
  }
  for (let i in hashadata) {
    param.docContentHash = hashadata[i]
  }
  return new Promise(function (resolve) {
    post.beginsigndoc(param).then(res => {
      if (res.success) {
        resolve(res.data)
      } else {
        onError(res)
        resolve(false)
      }
    }).catch(error => { console.log(error) })

  })
}
//如果签过
export function onsigncontracturl(fileobj) {
  let param = {
    yOffset: 10,
    xOffset: 10,
    docId: fileobj.signet.docId,
    signWay: 1,
    account: userinfo().username
  }
  post.getsigncontracturl(param).then(res => {
    if (res.success) {
      window.open(res.data.url)
    } else {
      onError(res)
    }
  }).catch(error => { console.log(error) })
}
//如果签过=固定签
export function signdocbyposition(templateVal, id) {
  let param = {
    account: userinfo().username,
    docId: templateVal.fileobj.signet.docId,
    signTemplateId: id
  }
  return new Promise(function (resolve) {
    post.signdocbyposition(param).then(res => {
      if (res.success) {
        resolve(res.data)
      } else {
        onError(res)
        resolve(false)
      }
    })
  })
}
//如果签过=批量固定签
export function signlistdocbyposition(templateVal, id) {
  let param = []
  for (let i in templateVal) {
    if (templateVal[i].signet) {
      param.push({
        account: userinfo().username,
        docId: templateVal[i].signet.docId,
        signTemplateId: id
      })
    } else {
      templateVal[i].msg = '当前文件合同签署失败'
    }
  }
  return new Promise(function (resolve) {
    post.signlistdocbyposition(param).then(res => {
      if (res.success) {
        resolve(res.data)
      } else {
        onError(res)
        resolve(false)
      }
    })
  })
}
//如果签过=关键字签
export function signdocbykeyword(templateVal, id) {
  let param = {
    account: userinfo().username,
    docId: templateVal.fileobj.signet.docId,
    signTemplateId: id
  }
  return new Promise(function (resolve) {
    post.signdocbykeyword(param).then(res => {
      if (res.success) {
        resolve(res.data)
      } else {
        onError(res)
        resolve(false)
      }
    })
  })
}
//如果签过=批量关键字签
export function signlistdocbykeyword(templateVal, id) {
  let param = []
  for (let i in templateVal) {
    if (templateVal[i].signet) {
      param.push({
        account: userinfo().username,
        docId: templateVal[i].signet.docId,
        signTemplateId: id
      })
    } else {
      templateVal[i].msg = '当前文件合同签署失败'
    }
  }
  return new Promise(function (resolve) {
    post.signlistdocbykeyword(param).then(res => {
      if (res.success) {
        resolve(res.data)
      } else {
        onError(res)
        resolve(false)
      }
    })
  })
}
// 归档
export function archivedoc(templateVal) {
  //如果签过
  let param = {
    account: userinfo().username,
    docId: templateVal.fileobj.signet.docId
  }
  return new Promise(function (resolve) {
    post.archivedoc(param).then(res => {
      if (res.success) {
        resolve(res.data)
      } else {
        onError(res)
      }
    }).catch(error => { console.log(error) })
  })
}
// 作废
export function refusesigndoc(fileobj) {
  //如果签过
  let param = {
    account: userinfo().username,
    docId: fileobj.signet.docId
  }
  return new Promise(function (resolve) {
    post.refusesigndoc(param).then(res => {
      if (res.success) {
        resolve(res.data)
      } else {
        onError(res)
      }
    }).catch(error => { console.log(error) })
  })
}
// 文件存证
export function dochashconf(fileobj) {
  let param = {
    docId: fileobj.signet ? fileobj.signet.docId : fileobj.docId
  }
  return new Promise(function (resolve) {
    post.dochashconf(param).then(res => {
      if(res.success){
        resolve(res.data)
      } else {
        onError(res)
      }
    }).catch(error => { console.log(error) })
  })
}
// 签证文件修改
export function updateapprovingca(command, formdata, approvingId, approvalId) {
  let param = {
    approvingId: approvingId,
    approvalId: approvalId
  }
  if (command.details) {
    param[command.details.title + '_' + command.details.type + '_' + command.item.title + '_' + command.item.type + '_' + command.details.index] = postFun(formdata)
  } else {
    param[command.item.title + '_' + command.item.type] = postFun(formdata)
  }
  //如果签过
  return new Promise(function (resolve) {
    if (!approvingId) {
      resolve(true)
    }
    post.updateapprovingca(param).then(res => {
      if (res.code === 0) {
        resolve(true)
      } else {
        onError(res)
      }
    }).catch(error => { console.log(error) })
  })
}
// 获取文件信息
export function docinfos(param){
  return new Promise(function (resolve) {
    post.docinfos(param).then(res => {
      if (res.success) {
        resolve(res)
      } else {
        onError(res)
      }
    }).catch(error => { console.log(error) })
  })
}

//新版设置服务器证书执行盖章操作 2023.4.3
export async function setServerStampBox(fileobj,command) {
  console.log("fileobj===",fileobj);
  console.log("command==",command);
  let fileUrl = fileobj.url;
  if(fileUrl.search("userfiles") != -1){
    fileUrl = fileUrl.replace("/userfiles/", "/confiles/")
  }
  //业务ID
  const randomHexStr = randomHexString() + randomHexString()
  //随机字符串
  const randomStr = randomString(32)
  let param = {
    appid: '8b9d8429c1bc11e9aea654e1ad008634',
    id: randomHexStr,
    serverCertId: command.item.signetTemp,
    nonce_str: randomStr,
    file: fileUrl,
    x: 156,
    y: 212,
    page: -1,
    format: 'pdf'
  }
  const key = '911a4818c1bc11e9aea654e1ad008634'
  const sign = generateSign(param, key)
  console.log("signsign==",sign);
  param.sign = sign
  param.file = encodeURI(fileUrl)
  return new Promise(function (resolve) {
    post.setServerStamp(param).then(res => {
      if (res.success) {
        // resolve(res.result)
        resolve(randomHexStr)
      } else {
        onError(res)
        resolve(false)
      }
    }).catch(error => { console.log(error) })

  })
}

function onError(res) {
  ElMessage.confirm(res.msg, '提示', {
    confirmButtonText: '确定',
    type: 'warning',
    center: true
  })
}

function userinfo () {
  return JSON.parse(localStorage.getItem('userMsg'))
}